<template>
    <!-- TODO: Update/Remove filters props to show the filters -->
    <y-rogue-wrapper
        name="profileTransactions"
        type="simple"
        :title="$t('dashboard.transactions.title')"
        :user-metadata="userMetadata"
        :filters="[]"
        raised
    />
</template>

<script>
    export default {
        name: 'DashboardTransactions',

        props: {
            userMetadata: Object,
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('dashboard.transactions.title'),
            };
        },
    };
</script>
